// extracted by mini-css-extract-plugin
export default {"bannerWrapper":"bannerWrapper_bannerWrapper__oNchr"};